import { useWindowSize } from '@calendly/hooks'
import { useEffect, useState } from 'react'

export const useContainerPosition = (containerRef) => {
  const { width, height } = useWindowSize()
  const [containerPosition, setContainerPosition] = useState({})

  useEffect(() => {
    if (!containerRef.current) return
    const { top, bottom } = containerRef.current.getBoundingClientRect()
    setContainerPosition({ top, bottom })
  }, [containerRef, width, height])

  return containerPosition
}
